import type { RootState } from 'js/src/libs/RootState';

export const getAudioEnhancementStatusForSceneGroup = (state: RootState, sceneGroupId: string) => {
    const audioEnhancementStatus =
        state.audio_enhancement.audio_enhancement_status.get(sceneGroupId);
    return audioEnhancementStatus;
};

export const getIsAudioEnhancementLoadingForSceneGroup = (
    state: RootState,
    sceneGroupId: string,
) => {
    return state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING.getIn([
        sceneGroupId,
        'isLoading',
    ]) as boolean;
};

export const getAudioEnhancementLoadingAbortController = (
    state: RootState,
    sceneGroupId: string,
) => {
    return state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING.getIn([
        sceneGroupId,
        'abortController',
    ]) as AbortController;
};
